import { object, string } from 'yup'

const phoneRegex =  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const generalSettingsSchema = object({
    name: string()
        .min(8, 'At least 8 charachters'),
    email: string()
        .email('Invalid Email'),
    phone: string()
        .matches(phoneRegex, 'Invalid phone number')
})